import React, { useLayoutEffect } from "react";
import "../components/styles/common.css";
import { Link } from "react-router-dom";
import lowPrice from "../assets/low-price.png";
import fastPayments from "../assets/money-transfer.png";
import shield from "../assets/shield.png";
import NavbarHome from "../components/ui/NavbarHome";

const AboutUs = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
});
  return (
    <div className="relative overflow-hidden">
      
      <NavbarHome/>

      <div className="h-full flex flex-col overflow-hidden text-black 2xl:w-4/5 w-4/5 m-auto font-nunito">
        <h1 className="text-3xl 2xl:text-4xl font-bold text-center mt-8">
          About Us
        </h1>
        <p className="text-xl 2xl:text-2xl mt-12">
          At <b>ScopeX</b>, we strive to improve cross-border financial services and
          trade costs, convenience, security, and accessibility. We assist
          people in moving money in a positive direction. By making cutting-edge
          financial services available to everyone, we are redefining the future
          of financial services and empowering our clients.
        </p>
        <h2 className="text-2xl 2xl:text-2xl font-semibold text-center mt-16 mb-12 px-4">
          But most significantly, by adhering to three principles, we ensure
          that your hard earned money is safe
        </h2>
        <div className="flex gap-6 py-12 ml-16 lg:justify-around flex-col md:flex-row ">
          <div className="flex flex-col w-4/5 items-center border-t-2 border-r-2 border-l-2 shadow-xl rounded-2xl py-10">
            <img src={lowPrice} alt="Low-cost icon" className="w-20" />
            <h3 className="text-xl 2xl:text-2xl font-bold mt-8">Low-cost</h3>
            <p className="w-4/5 2xl:text-xl text-center">
              ScopeX doesn't charge any fees to its users. We help you save
              1%-7% as compared to other remittance service providers.
            </p>
          </div>
          <div className="flex flex-col w-4/5 items-center border-t-2 border-r-2 shadow-xl rounded-2xl py-10">
            <img
              src={fastPayments}
              alt="Speedy transactions icon"
              className="w-24"
            />
            <h3 className="text-xl 2xl:text-2xl font-bold mt-4">
              Speedy transactions
            </h3>
            <p className="w-4/5 text-center 2xl:text-xl">
              Unlike most conventional banks and money transfer companies, we
              ensure that your fund transfer is rapid and straightforward by
              completing your transaction in minutes.
            </p>
          </div>
          <div className="flex flex-col w-4/5 items-center border-t-2 border-r-2 shadow-xl rounded-2xl py-10">
            <img src={shield} alt="Reliability icon" className="w-20" />
            <h3 className="text-xl 2xl:text-2xl font-bold mt-8">Reliability</h3>
            <p className="w-4/5 text-center 2xl:text-xl">
              We put a lot of effort into making your hard-earned money go
              further so that more may securely reach your dear ones.
            </p>
          </div>
        </div>
        <p className="p-4 px-12 text-center">
          If you have any queries, please{" "}
          <Link to="/Contact" className="font-bold">
            contact us
          </Link>
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
